/**
 * Kotlin's `Int.mod(Int)`, which — unlike JavaScript's `%` — always returns a
 * non-negative result. The tutor picks its replies with it, so keeping the
 * exact semantics keeps the ported engine choosing the same lines.
 */
export function mod(value: number, divisor: number): number {
  return ((value % divisor) + divisor) % divisor;
}
